import { useQuery } from '@tanstack/react-query';

import { UserProfileField } from 'types';

import { API_HANDLERS } from '../../apiHandlers';

interface UseProfileManagementLogicReturn {
  isLoading: boolean;
  userProfileFields: UserProfileField[];
}

export function useUserProfileFieldsQuery({
  management = false,
}: {
  management?: boolean;
}): UseProfileManagementLogicReturn {
  const { data, isLoading } = useQuery(['user-profile-fields'], () =>
    API_HANDLERS.SETTINGS.GET_USER_PROFILE_FIELDS(),
  );

  return {
    isLoading,
    userProfileFields: management
      ? data?.data.sort((a: { orders: number }, b: { orders: number }) => a.orders - b.orders) || []
      : data?.data
          ?.filter((field) => !field.hidden)
          .sort((a: { orders: number }, b: { orders: number }) => a.orders - b.orders) || [],
  };
}
